import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/vehiclesApi';
import * as types from '../constants/vehiclesConstants';

export const getVehiclesActions = (search) => async (dispatch) => {
  dispatch({ type: types.GET_VEHICLES_REQUEST });
  try {
    const { error, data } = await api.getVehicles(search);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_VEHICLES_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список автомобілів');
    dispatch({ type: types.GET_VEHICLES_FAILURE });
  }
};

export const clearVehiclesActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VEHICLES,
  });
};

export const setVehiclesPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_VEHICLES_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setVehiclesSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_VEHICLES_SEARCH,
    payload: search,
  });
};

export const nextVehiclesPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_VEHICLES_PAGE,
  });
};

export const prevVehiclesPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_VEHICLES_PAGE,
  });
};
